import React from 'react';

import { IIconProps, TIconType } from '../interface';

const UnlinkIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			fill='none'
			height={props?.height || '24'}
			viewBox='0 0 24 24'
			width={props?.width || '24'}
			{...props?.innerSvgProps}
		>
			<path
				d='M13.5937 16.7719L10.9406 19.425C10.5226 19.843 10.0264 20.1745 9.48032 20.4007C8.93422 20.6269 8.3489 20.7434 7.7578 20.7434C6.56401 20.7434 5.41912 20.2691 4.57499 19.425C3.73085 18.5809 3.25662 17.436 3.25662 16.2422C3.25662 15.0484 3.73085 13.9035 4.57499 13.0594L7.22811 10.4062'
				stroke={props?.color || '#2E2E6B'}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M16.7719 13.5938L19.425 10.9406C20.2691 10.0965 20.7434 8.9516 20.7434 7.75781C20.7434 6.56403 20.2691 5.41914 19.425 4.575C18.5809 3.73087 17.436 3.25664 16.2422 3.25664C15.0484 3.25664 13.9035 3.73087 13.0594 4.575L10.4062 7.22813'
				stroke={props?.color || '#2E2E6B'}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<line
				stroke={props?.color || '#2E2E6B'}
				strokeLinecap='round'
				x1='17.0509'
				x2='18.7438'
				y1='17.042'
				y2='18.7349'
			/>
			<line
				stroke={props?.color || '#2E2E6B'}
				strokeLinecap='round'
				x1='15.4125'
				x2='15.4125'
				y1='18.1115'
				y2='19.5115'
			/>
			<line
				stroke={props?.color || '#2E2E6B'}
				strokeLinecap='round'
				x1='18.0439'
				x2='19.4439'
				y1='15.342'
				y2='15.342'
			/>
			<line
				stroke={props?.color || '#2E2E6B'}
				strokeLinecap='round'
				x1='7.18007'
				x2='5.48718'
				y1='6.75677'
				y2='5.06388'
			/>
			<line
				stroke={props?.color || '#2E2E6B'}
				strokeLinecap='round'
				x1='8.81845'
				x2='8.81845'
				y1='5.68724'
				y2='4.28724'
			/>
			<line
				stroke={props?.color || '#2E2E6B'}
				strokeLinecap='round'
				x1='6.18716'
				x2='4.78716'
				y1='8.45677'
				y2='8.45677'
			/>
		</svg>
	);
};

export default UnlinkIcon;
